import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class CodeCommand extends AbstractConfDataCommand {
  codeFileId: number;
}